import React, { useState, useEffect, useRef } from 'react';
import Confetti from 'react-confetti'
import "../../../assets/css/modal.css";
import $ from 'jquery'

function ChristmasLoader() {
  const [count, setCount] = useState(0);
  const [showStyle, setShowStyle] = useState(false)
  const [showLogo, setShowLogo] = useState(false);
  const [version, setVersion] = useState(1);
  const countRef = useRef(0);

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    const randomVersion = Math.floor(Math.random() * 100) + 1;
    setVersion(randomVersion);
  }, []);
  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    const canvas = ref1.current;
    const ctx = canvas.getContext('2d');

    return () => {
    };
  }, []);


  useEffect(() => {

    $("body").css("overflow", "hidden");
    setTimeout(function () {
      $("#loadingdiv").fadeOut();
      $("body").css("overflowY", "visible");
      $("#root").fadeIn();
    }, 4780);
  }, []);

  function handleLoad() {
    setTimeout(function () {
      $("#loadingdiv").fadeOut();
      $("body").css("overflowY", "visible");
      $("#root").fadeIn();
    }, 4700);
  }

  return (
    <>
      <div className='conative-aniversary-loading-container' onLoad={handleLoad} >
        <div>
          <canvas ref={ref1} width={0} height={0} />
          <Confetti
            ref={ref1}
            colors={["#ffe5a2", "#bf841a", "#ffcd74"]}
            width={windowSize.width}
            height={windowSize.height}
            confettiSource={{
              x: windowSize.width,
              y: windowSize.height
            }}
            wind={-0.045}
            initialVelocityX={6}
            initialVelocityY={20}
            recycle={false}
            numberOfPieces={100}
          />
        </div>
        <div>
          <Confetti
            colors={["#ffe5a2", "#bf841a", "#ffcd74"]}
            ref={ref2}
            width={windowSize.width}
            height={windowSize.height}
            confettiSource={{
              x: -50,
              y: windowSize.height
            }}
            wind={0.045}
            initialVelocityX={6}
            initialVelocityY={20}
            recycle={false}
            numberOfPieces={100}

          />
        </div>

        <div className='aniversary-img-counter-wr'>
          <div className='aniversary-img-container'>

            <figure className='loader-outline-container'>
              <img src={`/assets/images/Logo_Outline.svg?v=${version}`} alt="Conative It Solutions" />
              <span className='loader-dot'></span>
            </figure>
            <figure className='loader-sparkle-container'>
              <img src="/assets/images/Sparkle.png" alt="Conative It Solutions" />
            </figure>
            <figure className='loader-wave-container'>
              <img src="/assets/images/Wave.png" alt="Conative It Solutions" />
            </figure>
          </div>

          <div className='loader-counter-container'>

            {/* counter start */}
            <div className='counter-inner-container'>
              <div class="counter-aniv">
                <div class="numbers">
                  {/* <div><span className='modal-counter-gradient-num'> 0</span></div> */}

                  <div><span className='modal-counter-gradient-num'> 1</span></div>
                  <div><span className='modal-counter-gradient-num'> 2</span></div>
                  <div><span className='modal-counter-gradient-num'> 3</span></div>
                  <div><span className='modal-counter-gradient-num'> 4</span></div>
                  <div><span className='modal-counter-gradient-num'> 5</span></div>
                  <div><span className='modal-counter-gradient-num'> 6</span></div>
                  <div><span className='modal-counter-gradient-num'> 7</span></div>
                  <div><span className='modal-counter-gradient-num'> 8</span></div>
                  <div><span className='modal-counter-gradient-num'> 9</span></div>
                  <div><span className='modal-counter-gradient-num'> 10</span></div>
                  <div><span className='modal-counter-gradient-num'> 11<sup class="counter-suffix">th</sup></span></div>



                </div>
              </div>
            </div>

            <div>
              <span className='counter-sub' >Anniversary</span>
            </div>

            {/* counter end */}
          </div>
        </div>
      </div>
    </>
  );
}

export default ChristmasLoader;
